import { Link } from 'react-router-dom';

// /cennik — Týž. 21. Model zdokumentovaný v docs/00-koncept-a-biznis.md §4
// ("kompletná história financií vždy zadarmo", priamy útok na Finstat paywall).
// Presná cena Predplatného (sledovanie) zámerne NIE JE stanovená — user
// explicitne rozhodol nechať "Kontaktujte nás" namiesto vymysleného čísla,
// kým sa neurčí biznis rozhodnutím. Modulárna štruktúra (Free/Predplatné/API/
// Enterprise ako samostatné osi, nie jeden monolitický balík) inšpirovaná
// prieskumom finstat.sk (2026-07-18) — ich MONITORING (95€/rok) je zámerne
// oddelený od plného dátového balíka PREMIUM (350€/rok), API/Datasety sú
// vlastná os predávaná bundled aj samostatne, vždy na dopyt (kontaktujte nás,
// žiadna verejná cena) — presne to, čo user chcel: "niekto nepotrebuje
// všetky informácie".
const sectionH = { fontSize: '1.02rem', marginTop: '1.6rem', color: 'var(--navy-900)' } as const;

interface Tier {
  name: string;
  price: string;
  tagline: string;
  features: string[];
  cta: { label: string; to: string };
  highlight?: boolean;
}

const TIERS: Tier[] = [
  {
    name: 'Zadarmo',
    price: '0 €',
    tagline: 'Bez limitu, bez registrácie',
    features: [
      'Profil firmy, plná história účtovných závierok',
      'Graf prepojení osôb a firiem',
      'Risk skóre vrátane Altman Z"',
      'Vyhľadávanie a filtrovanie firiem',
      'Insolvenčný feed, register partnerov verejného sektora',
    ],
    cta: { label: 'Vyhľadať firmu', to: '/vyhladavanie' },
  },
  {
    name: 'Predplatné',
    price: 'Kontaktujte nás',
    tagline: 'Sledovanie a alerty nad rámec free limitu',
    features: [
      'Neobmedzené sledovanie firiem (watchlist)',
      'Sledovanie insolvenčných udalostí podľa vlastného záujmu',
      'E-mailové alerty na zmeny (názov, sídlo, štatutári)',
      'Skupiny a poznámky vo watchliste',
    ],
    cta: { label: 'Napísať nám', to: '/ucet' },
    highlight: true,
  },
  {
    name: 'API',
    price: 'Kontaktujte nás',
    tagline: 'Integrácia dát priamo do vášho systému',
    features: [
      'Profil, financie, risk skóre a graf prepojení cez REST API',
      'Hromadné skórovanie (bulk risk score)',
      'Vlastný API kľúč, denný limit podľa balíka',
      'JSON, dokumentácia s príkladmi',
    ],
    cta: { label: 'Dokumentácia API', to: '/dokumentacia-api' },
  },
  {
    name: 'Enterprise',
    price: 'Kontaktujte nás',
    tagline: 'Banky, leasingovky, vymáhačky vo väčšom',
    features: [
      'Hromadné skórovanie nad rámec free limitu',
      'SLA a prioritná podpora',
      'Vlastný dátový feed na mieru',
    ],
    cta: { label: 'Napísať nám', to: '/ucet' },
  },
];

export function PricingPage() {
  return (
    <main className="page page-narrow">
      <h1 style={{ fontSize: '1.4rem' }}>Cenník</h1>
      <p style={{ color: 'var(--slate)', fontSize: '0.92rem', lineHeight: 1.6 }}>
        Dáta (profil firmy, plná história financií, graf prepojení, risk skóre) sú{' '}
        <b>navždy zadarmo a bez limitu</b> — platí sa len za automatizáciu a mierku:
        sledovanie/alerty, API integrácie a hromadné spracovanie. Nie je to skryté za paywallom ako
        u konkurencie.
      </p>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))',
          gap: '1rem',
          marginTop: '1.5rem',
        }}
      >
        {TIERS.map((tier) => (
          <div
            key={tier.name}
            className="card"
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.6rem',
              border: tier.highlight ? '2px solid var(--brand)' : undefined,
            }}
          >
            <div>
              <h2 style={{ fontSize: '1.05rem', margin: 0 }}>{tier.name}</h2>
              <span className="hint">{tier.tagline}</span>
            </div>
            <div style={{ fontSize: '1.3rem', fontWeight: 700 }}>{tier.price}</div>
            <ul style={{ margin: 0, paddingLeft: '1.1rem', fontSize: '0.85rem', flex: 1 }}>
              {tier.features.map((f) => (
                <li key={f} style={{ marginBottom: '0.35rem' }}>
                  {f}
                </li>
              ))}
            </ul>
            <Link
              to={tier.cta.to}
              className={tier.highlight ? 'pill mid' : 'pill'}
              style={{ textAlign: 'center', display: 'block' }}
            >
              {tier.cta.label}
            </Link>
          </div>
        ))}
      </div>

      <div style={{ color: 'var(--ink)', fontSize: '0.92rem', lineHeight: 1.7 }}>
        <h3 style={sectionH}>Prečo nemáme balíky ako konkurencia</h3>
        <p>
          Finstat aj Foaf držia kľúčové dáta (financie, graf prepojení) za platenými balíkmi od
          15–25 €/mes. vyššie. Robíme presný opak — dáta ťahajú dôveru a návštevnosť, platí sa za
          to, čo dáta automatizuje alebo škáluje (sledovanie desiatok firiem naraz, API volania,
          hromadné skórovanie).
        </p>

        <h3 style={sectionH}>Potrebujete niečo iné?</h3>
        <p>
          Nie každý potrebuje všetko naraz — ak vás zaujíma len sledovanie konkrétnych firiem, len
          API prístup, alebo len hromadné spracovanie,{' '}
          <a href="mailto:info@marstein.sk">napíšte nám</a> a dohodneme rozsah presne podľa potreby.
        </p>
      </div>
    </main>
  );
}
